import { createAction, props } from "@ngrx/store";
import ICertification from "@skills-app/models/certification";

const prefix = "[Certification Search Bar]";

export const addCertificationToSearch = createAction(
  `${prefix} Add Certification To Search`,
  props<{ certification: ICertification }>(),
);
export const removeCertificationFromSearch = createAction(
  `${prefix} Remove Certification From Search`,
  props<{ certification: ICertification }>(),
);
export const addAllCertificationsToSearch = createAction(
  `${prefix} Add All Certifications To Search`,
  props<{ certifications: ICertification[] }>(),
);
export const removeAllCertificationsFromSearch = createAction(
  `${prefix} Remove All Certifications From Search`,
);
